// import $ from 'jquery';

/**
 *  Input with bottom border disappearing as you type.
 */
(function compactInput() {
    $('.compact-input').each((i, root) => {
        const $root = $(root);
        if (!$root.hasClass('handled')) { // prevent processing input twice
            $root.addClass('handled');
            const $input = $root.find('input');
            const $mask = $root.find('.border-mask');
            const placeholder = $input.attr('placeholder');
            function updateBorder() {
                const val = $input.val();
                $root.toggleClass('empty', !val);
                $mask.text(val || placeholder);
                $root.get(0).style.setProperty('--text-width', $mask.outerWidth() + 'px');
                setTimeout(() => {
                    $root.addClass('no-border-transition');
                }, 200);
            }
            $input.on('input', updateBorder);
            $root.on('update-border', updateBorder);
            updateBorder();
        }
    });
})();